var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6611 8.33072C16.882 8.33072 17.0939 8.24295 17.2502 8.08672C17.4064 7.93049 17.4942 7.7186 17.4942 7.49766V4.99846C17.4942 4.77752 17.4064 4.56563 17.2502 4.4094C17.0939 4.25317 16.882 4.1654 16.6611 4.1654H14.5784C14.4491 4.1654 14.3216 4.13529 14.2059 4.07745C14.0902 4.01961 13.9896 3.93563 13.912 3.83217L13.1622 2.83249C13.0846 2.72903 12.984 2.64505 12.8683 2.58722C12.7527 2.52938 12.6251 2.49927 12.4958 2.49927H10.8296C10.6087 2.49927 10.3968 2.58704 10.2406 2.74327C10.0844 2.8995 9.99658 3.11139 9.99658 3.33233V7.49766C9.99658 7.7186 10.0844 7.93049 10.2406 8.08672C10.3968 8.24295 10.6087 8.33072 10.8296 8.33072H16.6611Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6611 17.4943C16.882 17.4943 17.0939 17.4065 17.2502 17.2503C17.4064 17.0941 17.4942 16.8822 17.4942 16.6612V14.162C17.4942 13.9411 17.4064 13.7292 17.2502 13.573C17.0939 13.4167 16.882 13.329 16.6611 13.329H14.2452C14.0928 13.327 13.9438 13.2832 13.8146 13.2024C13.6853 13.1216 13.5807 13.0069 13.5121 12.8708L13.1622 12.1627C13.0972 12.0137 12.99 11.8869 12.8538 11.7981C12.7176 11.7093 12.5584 11.6623 12.3958 11.6628H10.8296C10.6087 11.6628 10.3968 11.7506 10.2406 11.9068C10.0844 12.0631 9.99658 12.275 9.99658 12.4959V16.6612C9.99658 16.8822 10.0844 17.0941 10.2406 17.2503C10.3968 17.4065 10.6087 17.4943 10.8296 17.4943H16.6611Z",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49902 4.16528C2.49902 4.60717 2.67456 5.03095 2.98702 5.34341C3.29948 5.65587 3.72327 5.83141 4.16515 5.83141H6.66435",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49902 2.49927V13.3291C2.49902 13.771 2.67456 14.1948 2.98702 14.5072C3.29948 14.8197 3.72327 14.9952 4.16515 14.9952H6.66435",
    stroke: "#6B7280",
    strokeWidth: 1.66613,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon04);
export default __webpack_public_path__ + "static/media/icon04.a7896f393d68eaaaff7696145561666a.svg";
export { ForwardRef as ReactComponent };